module.exports = __webpack_public_path__ + "static/media/handshake_640_color.be06ba5b.png";